export default __webpack_public_path__ + "static/media/car-enthusiats.26aef8c2.gif";